import React from "react"
import { View } from "react-native"
import { style } from "./styles"
import LinearGradient from "react-native-linear-gradient"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import { Text } from "components/Text"
import { useNavigation } from "@react-navigation/native"
import { CustomHeaderPropsHeaderProps } from "./props"
import Constants from "expo-constants"
import { useColor } from "app/theme/getThemes"
import { translate } from "i18n"

export const CustomHeader = (props: CustomHeaderPropsHeaderProps) => {
  const {
    headerTitle,
    height,
    showBackButton = true,
    withBalls,
    children,
    longHeader,
    headerRight,
    containerStyle,
    loading,
  } = props
  const navigation = useNavigation()
  const statusBarHeight = Constants.statusBarHeight
  const { companyTheme } = useColor()

  // --------------------RENDER
  return headerTitle === translate("memberQrScreen.title") ||
    headerTitle === translate("referralScreen.title") ? (
    <View
      style={[
        style.linearGradient,
        height ? { height } : longHeader ? { height: 150 } : { height: 70 },
        { marginTop: statusBarHeight ? statusBarHeight + 5 : 0 },

        containerStyle,
      ]}
    >
      <View style={style.container}>
        <View style={style.headerContentContainer}>
          {showBackButton && (
            <MaterialIcons
              name="chevron-left"
              color="white"
              size={38}
              onPress={() => {
                loading ? null : navigation.goBack()
              }}
            />
          )}
          <Text style={style.headerTitle}>{headerTitle}</Text>
          {headerRight && <View style={style.rightContainer}>{headerRight()}</View>}
        </View>
        {children}
      </View>

      {withBalls && (
        <>
          <View style={style.ball1} />
          <View style={style.ball2} />
          <View style={style.ball3} />
          <View style={style.ball4} />
        </>
      )}
    </View>
  ) : (
    <LinearGradient
      style={[
        style.linearGradient,
        height ? { height } : longHeader ? { height: 150 } : { height: 70 },
        { marginTop: statusBarHeight ? statusBarHeight + 5 : 0 },

        containerStyle,
      ]}
      colors={[companyTheme?.first || "white", companyTheme?.second || "white"]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
    >
      <View style={style.container}>
        <View style={style.headerContentContainer}>
          {showBackButton && (
            <MaterialIcons
              name="chevron-left"
              color="white"
              size={38}
              onPress={() => {
                loading ? null : navigation.goBack()
              }}
            />
          )}
          <Text style={style.headerTitle}>{headerTitle}</Text>
          {headerRight && <View style={style.rightContainer}>{headerRight()}</View>}
        </View>
        {children}
      </View>

      {withBalls && (
        <>
          <View style={style.ball1} />
          <View style={style.ball2} />
          <View style={style.ball3} />
          <View style={style.ball4} />
        </>
      )}
    </LinearGradient>
  )
}
